import moment from 'moment';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import React from 'react';
import {withTranslation} from 'react-i18next';
import publicIp from 'react-public-ip';
import {v4 as uuidv4} from 'uuid';
import BaseContainer from '../baseContainers/BaseContainer';
import {ActionButton} from '../components/ActionButton';
import {ActionLink} from '../components/ActionLink';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import FuelCardComponent from '../components/FuelCardComponent';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import PhoneNumberComponent from '../components/PhoneNumberComponent';
import {Steps} from '../components/StepsComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import AutoRegistrationService from '../services/AutoRegistrationService';
import SettingService from '../services/SettingService';
import SelectCustomerDialog from './SelectCustomerDialog';
import { Card } from 'primereact/card';
import {Dialog} from 'primereact/dialog';

class AutoRegistrationContainer extends BaseContainer {
    constructor(props) {
        super(props);
        const {t} = this.props;
        this.autoRegistrationService = new AutoRegistrationService();
        this.settingService = new SettingService();
        this.renderFirstPage = this.renderFirstPage.bind(this);
        this.renderSecondPage = this.renderSecondPage.bind(this);
        this.renderThirdPage = this.renderThirdPage.bind(this);
        this.renderFourthPage = this.renderFourthPage.bind(this);
        this.renderFinalPage = this.renderFinalPage.bind(this);
        this.renderBackButton = this.renderBackButton.bind(this);
        this.renderNextButton = this.renderNextButton.bind(this);
        this.renderAddCardButton = this.renderAddCardButton.bind(this);
        this.renderDeleteCardButton = this.renderDeleteCardButton.bind(this);
        this.addFuelCard = this.addFuelCard.bind(this);
        this.renderStepsNav = this.renderStepsNav.bind(this);
        this.renderToLoginButton = this.renderToLoginButton.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.setCheckAll = this.setCheckAll.bind(this);
        this.uncheckAll = this.uncheckAll.bind(this);
        this.checkCheckAll = this.checkCheckAll.bind(this);
        this.checkPromoCode = this.checkPromoCode.bind(this);
        this.completeRegistration = this.completeRegistration.bind(this);
        this.state = {
            pageIndex: 0,
            errorCode: undefined,
            maxFuelCards: 5,
            checkAll: undefined,
            invoiceTypeDescriptions: [t('autoRegistration.invoiceDescription1'), t('autoRegistration.invoiceDescription2')],
            invoiceTypeOptions: [],
            companyStatusOptions: [],
            fuelCardTypeOptions: [],
            companyBusinessOptions: [],
            customerOptions: [],
            registrationStart: undefined,
            selectedCustomer: undefined,
            selectCustomerDialogVisible: false,
            flatRateFarmerDialogVisible: false,
            agreementTypeOptions: [],
            telephoneCodeOptions: [],
            provinceOptions: [],
            fuelCardAppRoleOptions: [
                //placeholder
                {enumValue: 'DRIVER', label: t('AccountRole.DRIVER')},
                {enumValue: 'ADMIN', label: t('AccountRole.ADMIN')},
            ],
            cardOptions: [
                {enumValue: 'PLASTIC', label: t('autoRegistration.cardPlasticBasic'), description: t('autoRegistration.plasticCardDescription')},
                {enumValue: 'PLASTIC_MULTIENERGETIC', label: t('autoRegistration.cardPlasticMultienergetic'), description: t('autoRegistration.electromobilityCardDescription')},

            ],
            flatRateFarmerOptions: [
                {enumValue: 'SELF_EMPLOYED', label: t('autoRegistration.nonFlatRateFarmerMessage')},
                {enumValue: 'FLAT_RATE_FARMER', label: t('autoRegistration.flatRateFarmerMessage')},
            ],
            flatRateFarmer: false,
            approvals: [],
            element: {
                ownerPhoneCode: undefined,
                ownerPhoneValue: '',
                userIp: '',
                promoCodeId: '',
                promoCodeDateFrom: '',
                promoCodeDateTo: '',
                promoCode: '',
                offerType: '',
                tin: '',
                regon: '',
                ownerEmail: '',
                companyName: '',
                email: '',
                ownerPhone: '',
                companyBusiness: undefined,
                companyStatus: undefined,
                companyContactAddress: '',
                contactStreet: '',
                contactNumber: '',
                contactPostCode: '',
                contactPostOffice: '',
                invoiceType: 'ELECTRONIC',
                invoiceFrequency: undefined,
                cards: [],
                cardCompanyName: '',
                marketingConsent: false,
                phoneMarketing: false,
                emailMarketing: false,
                //newsletterMarketingConsent: false,
                approvalContent3: false,
                petraAgreements:[],
                existsInOtherRole: undefined,
                cbkId: undefined,
                customerDataChange: false,
                fullAddress: {
                    city: '',
                    street: '',
                    streetNumber: '',
                    flatNumber: '',
                    postCode: '',
                    postOffice: '',
                    provinceId: '',
                },
                companyAuthorized: false,
                flatRateFarmer: undefined,
                vehicleType: undefined,
            },
        };
    }

    componentDidMount() {
        if (this.authService.loggedIn()) {
            this.props.history.replace('/403');
        }
        super.componentDidMount();
        this.blockUi();
        const {t} = this.props;
        this.enumService
            .getEnumListWithDescription('EcInvoiceType', t)
            .then((invoiceTypeOptions) => {
                let noPaperOptions = invoiceTypeOptions?.filter(o => o.enumValue !== "PAPER");
                this.setState(
                    {
                        invoiceTypeOptions : noPaperOptions,
                    },
                    () => {
                        this.unblockUi();
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage(t('error.typeInvoiceListError'));
                this.unblockUi();
            });
        this.enumService
            .getEnumListWithDescription('EcInvoiceFrequency', t)
            .then((invoiceFrequencyOptions) => {
                this.setState(
                    {
                        invoiceFrequencyOptions,
                    },
                    () => {
                        this.unblockUi();
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage(t('error.typeInvoiceFrequencyListError'));
                this.unblockUi();
            });
        this.enumService
            .getEnumListWithDescription('EcCardKind', t)
            .then((fuelCardTypeOptions) => {
                this.setState(
                    {
                        fuelCardTypeOptions,
                    },
                    () => {
                        this.unblockUi();
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage(t('error.typeInvoiceFrequencyListError'));
                this.unblockUi();
            });
        this.settingService
            .getTelephoneCodeList()
            .then((telephoneCodeOptions) => {
                if (this._isMounted) {
                    this.setState({
                        telephoneCodeOptions: telephoneCodeOptions,
                    });
                }
            })
            .catch(() => {});
        this.settingService
            .getProvinceList()
            .then((provinceOptions) => {
                if (this._isMounted) {
                    this.setState({
                        provinceOptions: provinceOptions,
                    });
                }
            })
            .catch(() => {});
        publicIp.v4().then((response) => {
            this.setState((prevState) => ({
                ...prevState,
                element: {
                    ...prevState.element,
                    userIp: response,
                },
            }));
        });
        this.autoRegistrationService
            .getApprovals(this.state.element.offerType)
            .then((approvals) => {
                this.setState({approvals});
            })
            .catch((err) => {
                console.log(err);
            });
        this.autoRegistrationService
            .registrationAgreementTypes()
            .then((registrationAgreementTypes) => {
                let agreementTypeOptions = [];
                if (registrationAgreementTypes !== undefined && registrationAgreementTypes !== null) {
                    registrationAgreementTypes.forEach((type) => {
                        agreementTypeOptions.push({
                            enumValue: type,
                            label: `${t(`autoRegistration.registrationAgreementTypes.${type}.label`)}`,
                            description: `${t(`autoRegistration.registrationAgreementTypes.${type}.[html]description`)}`,
                        });
                    });
                }
                this.setState({agreementTypeOptions});
            })
            .catch((err) => {
                this.showErrorMessage(t('autoRegistration.registrationAgreementTypes.error'));
            });
            this.settingService
            .getVehicleTypes()
            .then((vehicleTypeOpt) => {
                if (this._isMounted) {
                    this.setState({
                        vehicleTypeOpt,
                    });
                }
            })
            .catch(() => {});
    }

    componentDidUpdate() {
        this.checkCheckAll();
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    checkPromoCode(code) {
        this.blockUi();
        const {t} = this.props;
        this.autoRegistrationService
            .checkPromoCode(code)
            .then((response) => {
                this.setState((prevState) => ({
                    ...prevState,
                    element: {
                        ...prevState.element,
                        promoCodeId: response.id,
                        promoCodeDateFrom: moment(response.dateFrom),
                        promoCodeDateTo: moment(response.dateTo),
                        promoCode: response.code,
                    },
                }));
                this.unblockUi();
            })
            .then(() => {
                const date = new Date();
                if (this.state.element.promoCodeDateFrom < date && this.state.element.promoCodeDateTo > date) {
                    this.setState({promoCodeValid: true});
                } else {
                    throw new Error();
                }
            })
            .catch((err) => {
                this.setState({
                    promoCodeValid: false,
                });
                if(err?.integrationErrorCode === 3){
                    this.showErrorMessage(t('autoRegistration.expiredRegisterCode'));
                } else {
                    this.showErrorMessage(t('autoRegistration.invalidRegisterCode'));
                }
                this.unblockUi();
            });
    }

    registrationStart() {
        this.blockUi();
        const {t} = this.props;
        this.autoRegistrationService
            .registrationStart(t)
            .then((response) => {
                this.setState(
                    {
                        registrationStart: response,
                        companyStatusOptions: response.companyStatus,
                        companyBusinessOptions: response.tradeList,
                    },
                    () => this.unblockUi()
                );
            })
            .catch(() => {
                this.showErrorMessage(t('error.registrationStartError'));
                this.unblockUi();
            });
    }

    normalizeNip() {
       return this.state.element?.tin.split('-').join('');
    };

    completeRegistration() {
        this.blockUi();
        const {t} = this.props;
        const {element} = this.state;
        element.tin = this.normalizeNip();
        if (
            element.ownerPhoneCode !== undefined &&
            element.ownerPhoneCode !== null &&
            element.ownerPhoneValue !== undefined &&
            element.ownerPhoneValue !== null &&
            element.ownerPhoneValue !== ''
        ) {
            element.ownerPhone = element.ownerPhoneCode.code + element.ownerPhoneValue;
        }
        this.autoRegistrationService
            .completeRegistration(element)
            .then(() => {
                this.unblockUi(this.setState({pageIndex: 4, errorCode: undefined}));
            })
            .catch((err) => {
                if (err.integrationErrorCode === 10) {
                    this.unblockUi(this.setState({pageIndex: 4, errorCode: err.integrationErrorCode}));
                } else if(err.integrationErrorCode === 12){
                    this.showErrorMessage(t('error.autoRegistrationCodeError'));
                    this.unblockUi();
                } else {
                    this.showErrorMessage(t('error.autoRegistrationError'));
                    this.unblockUi();
                }
            });
    }

    renderFirstPage() {
        const {t} = this.props;
        return (
            <DivContainer colClass='row gutter-x-24'>
                {this.state.selectCustomerDialogVisible === true ? (
                    <SelectCustomerDialog
                        visible={true}
                        onHide={() => {
                            this.setState({selectCustomerDialogVisible: false});
                        }}
                        closeable
                        className=''
                        renderHeader={() => (
                            <React.Fragment>
                                <DivContainer colClass='col-12 back-off-auth-dialog-header'>
                                    <DivContainer colClass='col-12'>
                                        <label id={`auth-dialog-header-label-id`}>{`${t('autoRegistration.selectCustomerHeader')}`}</label>
                                    </DivContainer>
                                </DivContainer>
                            </React.Fragment>
                        )}
                        handleSuccess={(customer) =>
                            this.setState(
                                (prevState) => ({
                                    prevState,
                                    pageIndex: 1,
                                    selectCustomerDialogVisible: false,
                                    element: {
                                        ...prevState.element,
                                        fullAddress: {
                                            city: customer.fullAddress.city,
                                            street: customer.fullAddress.street,
                                            streetNumber: customer.fullAddress.streetNumber,
                                            flatNumber: customer.fullAddress.flatNumber,
                                            postCode: customer.fullAddress.postCode,
                                            postOffice: customer.fullAddress.postOffice,
                                            provinceId: customer.fullAddress.provinceId,
                                        },
                                        companyName: customer.fullName,
                                        email: customer.email,
                                        existsInOtherRole: customer.existsInOtherRole,
                                        regon: customer.regon,
                                        cbkId: customer.cbkId,
                                        customerDataChange: customer.customerDataChange,
                                    },
                                }),
                                this.registrationStart()
                            )
                        }
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showMessage={this.showMessage}
                        embedded
                        _isMounted={this._isMounted}
                        mainRef={this.props.mainRef}
                        customerOptions={this.state.customerOptions}
                        provinceOptions={this.state.provinceOptions}
                    />
                ) : null}
                <div className='header' dangerouslySetInnerHTML={{__html: `1. ${t('autoRegistration.promoCode_html')}`}} />
                <InputTextComponent
                    id='promoCode'
                    name='promoCode'
                    label={t('autoRegistration.haveCode')}
                    colClass='col-md-4 col-sm-12'
                    value={this.state.element.promoCode}
                    viewMode='NEW'
                    validator={this.validator}
                    validators='not_required'
                    onChange={this.handleChange}
                    onBlur={(e) => {
                        e.preventDefault();
                        if (this.state.element.promoCode && this.state.element.promoCode !== '') {
                            this.setState({
                                promoCodeValid: undefined,
                            });
                            this.checkPromoCode(this.state.element.promoCode);
                        }
                    }}
                    onInput={(e) => {
                        e.preventDefault();
                        if (this.state.element.promoCode && this.state.element.promoCode !== '') {
                            this.setState({
                                promoCodeValid: undefined,
                            });
                        }
                    }}
                    iconName={
                        this.state.element.promoCode !== ''
                            ? this.state.promoCodeValid
                                ? 'mdi-check-circle'
                                : this.state.promoCodeValid === false
                                ? 'mdi-close-circle'
                                : ''
                            : ''
                    }
                    iconSide='right'
                    iconSize='m'
                    iconColor={'registration-code-check ' + (this.state.promoCodeValid ? 'black' : 'red')}
                />
                <div className='col-12'></div>
                <div className='header'>{`2. ${t('autoRegistration.chooseOffer')}`}</div>
                <div className='row card-type-buttons'>
                    {this.state.agreementTypeOptions.map((card, index) => {
                        return (
                            <ActionButton
                                key={`card-type-${index}`}
                                label={card.label}
                                id={`card-type-${index}`}
                                variant={
                                    this.state.element.offerType === card.enumValue
                                        ? 'button white-pressed card-type'
                                        : 'button white-black card-type'
                                }
                                colClass='col-md-4'
                                inputLikeStyle={true}
                                description={<div dangerouslySetInnerHTML={{__html: card.description}} />}
                                showDescription={true}
                                descriptionClassName='card-type-description'
                                handleClick={
                                    card.enumValue !== this.state.element.offerType
                                        ? () =>
                                              this.setState(
                                                  (prevState) => ({
                                                      element: {
                                                          ...prevState.element,
                                                          offerType: card.enumValue,
                                                      },
                                                  }),
                                                  () => {
                                                      this.autoRegistrationService
                                                          .getApprovals(this.state.element.offerType)
                                                          .then((approvals) => {
                                                              this.setState({approvals});
                                                          })
                                                          .catch((err) => {
                                                              console.log(err);
                                                          });
                                                  }
                                              )
                                        : null
                                }
                            />
                        );
                    })}
                </div>

                <div className='header'>{`3. ${t('autoRegistration.provideYourData')}`}</div>
                <InputTextComponent
                    id='tin'
                    name='tin'
                    label={t('autoRegistration.TIN')}
                    colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                    value={this.state.element.tin}
                    viewMode='NEW'
                    validator={this.validator}
                    validators='required|nip'
                    onChange={this.handleChange}
                    required
                    renderRequired
                />
                <InputTextComponent
                    id='ownerEmail'
                    name='ownerEmail'
                    label={t('autoRegistration.email')}
                    colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                    value={this.state.element.ownerEmail}
                    viewMode='NEW'
                    validator={this.validator}
                    validators='required|email'
                    onChange={this.handleChange}
                    required
                    renderRequired
                />
                <div className='row footer-buttons'>
                    {this.renderBackButton(0)}
                    {this.renderNextButton(1)}
                </div>
            </DivContainer>
        );
    }

    renderSecondPage() {
        const {t} = this.props;
        this.state.element.ownerPhoneCode =
            this.state.element.ownerPhoneCode === undefined ? this.state.telephoneCodeOptions[0] : this.state.element.ownerPhoneCode;
        return (
            <DivContainer colClass='row gutter-x-24'>
                                {this.state.flatRateFarmerDialogVisible ? 
                 <Dialog
                 ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                visible={this.state.flatRateFarmerDialogVisible}
                className='farmer-statement-dialog' 
                key={`farmer-dialog`}
                closable={false}
             >
                  <Card
                  footer={() => {
                      const {t} = this.props;
                      return (
                          <div className='footer-dialog-button-container'>
                              <ActionButton
                                  label={t('autoRegistration.farmerConfirm')}
                                  variant='right-button save-button blue'
                                  handleClick={(e) => {
                                      e.preventDefault();
                                      this.handleCloseFlatRateFarmerDialog();
                                  }}
                              />
                          </div>
                      );
                  }}
              >
                  <div className='confirm-dialog-label'>{t('autoRegistration.flatRateFarmerDialogContent1')}</div>
                  <div className='confirm-dialog-label'>{t('autoRegistration.flatRateFarmerDialogContent2')}</div>
                  <div className='confirm-dialog-label'>{t('autoRegistration.flatRateFarmerDialogContent3')}</div>
              </Card>
             </Dialog> : null}
            
                <div className='header'>{`4. ${t('autoRegistration.companyData')}`}</div>
                <div className='row'>
                    <InputTextComponent
                        id='companyName'
                        name='companyName'
                        label={t('profile.companyName')}
                        colClass='col-md-3 col-sm-12'
                        value={this.state.element.companyName}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                    />
                    <InputTextComponent
                        id='tin'
                        name='tin'
                        label={t('profile.tin')}
                        colClass='col-md-3 col-sm-12'
                        value={this.state.element.tin}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                    />
                    {this.state.element.customerDataChange === false ? (
                        <InputTextComponent
                            id='companyAddress'
                            name='companyAddress'
                            label={t('autoRegistration.address')}
                            colClass='col-md-3 col-sm-12'
                            value={`${
                                this.state.element.fullAddress.street
                                    ? this.state.element.fullAddress.street
                                    : this.state.element.fullAddress.city
                            } ${
                                this.state.element.fullAddress.flatNumber
                                    ? `${this.state.element.fullAddress.streetNumber}/${this.state.element.fullAddress.flatNumber}`
                                    : this.state.element.fullAddress.streetNumber
                            } ${this.state.element.fullAddress.postCode} ${this.state.element.fullAddress.city} ${
                                this.state.element.fullAddress.provinceId
                                    ? `woj. ${
                                          this.state.provinceOptions
                                              .find((el) => el.petraId === this.state.element.fullAddress.provinceId)
                                              ?.name?.toUpperCase() ?? ''
                                      }`
                                    : ''
                            }`}
                            viewMode={'VIEW'}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                        />
                    ) : null}
                    <InputTextComponent
                        id='email'
                        name='email'
                        label={t('autoRegistration.email')}
                        colClass='col-md-3 col-sm-12'
                        value={this.state.element.email}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                    />
                    {this.state.element.customerDataChange === true ? (
                        <div className='row other-address'>
                            <InputTextComponent
                                id='fullAddress.city'
                                name='city'
                                stateField='element.fullAddress'
                                label={t('address.town')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.city}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputTextComponent
                                id='fullAddressStreet'
                                name='street'
                                stateField='element.fullAddress'
                                label={t('address.street')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.street}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='not_required'
                                onChange={this.handleChange}
                            />
                            <InputTextComponent
                                id='fullAddressStreetNumber'
                                name='streetNumber'
                                stateField='element.fullAddress'
                                label={t('address.streetNumber')}
                                colClass='col-md-2 col-sm-6'
                                value={this.state.element.fullAddress.streetNumber}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputTextComponent
                                id='fullAddressFlatNumber'
                                name='flatNumber'
                                stateField='element.fullAddress'
                                label={t('address.flatNumber')}
                                colClass='col-md-2 col-sm-6'
                                value={this.state.element.fullAddress.flatNumber}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='not_required'
                                onChange={this.handleChange}
                            />
                            <div className='col-12'></div>
                            <InputTextComponent
                                id='fullAddressPostCode'
                                name='postCode'
                                stateField='element.fullAddress'
                                label={t('address.postCode')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.postCode}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required|zipcode'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputTextComponent
                                id='fullAddressPostOffice'
                                name='postOffice'
                                stateField='element.fullAddress'
                                label={t('address.postOffice')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.postOffice}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputDropdownComponent
                                id='fullAddressProvince'
                                name='provinceId'
                                stateField='element.fullAddress'
                                label={t('address.voivodeship')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.provinceId}
                                enumMode={true}
                                viewMode='NEW'
                                validator={this.validator}
                                validators='required'
                                options={this.state.provinceOptions}
                                optionValue={'petraId'}
                                onChange={this.handleChange}
                                dataKey='petraId'
                                optionLabel='name'
                                required
                                renderRequired
                            />
                        </div>
                    ) : null}
                   
                    <InputCheckboxComponent
                        id={'companyAuthorized'}
                        name='companyAuthorized'
                        label={t('autoRegistration.companyAuthorizedMessage')}
                        stateField='element'
                        labelOnRight
                        value={this.state.element.companyAuthorized}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators={'required|accepted'}
                        validatorLabel=''
                        labelClassName='p-label'
                        required={true}
                        renderRequired={true}
                        colClass='col-width-auto'
                    />
                     {/* oswiadczenie rolnikow ryczałtowych - flat rate farmers */}
                     
                     <div className='farmers'> <span className='icon-svg left-label red-star '>*</span>Oświadczam, że</div>
                     <div className='flat-rate-farmer-ratiobuttons'>
                     <InputRadioButtonComponent
                        id='flatRateFarmer'
                        name='flatRateFarmer'
                        label={t('autoRegistration.flatRateFarmerStatement')}
                        showLabel={false}
                        colClass='col-12'
                        //className='flat-rate-farmer-ratiobuttons'
                        //descriptionClassName='flat-rate-farmer-ratiobuttons'
                        value={this.state.element.flatRateFarmer}
                        viewMode={'EDIT'}
                        labelOnRight
                        onChange={this.handleChange}
                        options={this.state.flatRateFarmerOptions}
                        validator={this.validator}
                        valueLabel='label'
                        valueKey='enumValue'
                        itemColClass={'col-md-12 col-sm-12'}
                        validators='required'
                    />
                     </div>
                    <PhoneNumberComponent
                        id='ownerPhone-dialog'
                        nameCode='ownerPhoneCode'
                        namePhoneNumber='ownerPhoneValue'
                        labelCode={t('cards.phoneNumberCode')}
                        labelPhoneNumber={t('autoRegistration.phone')}
                        colClass='col-xl-4 col-lg-4 col-md-8 col-sm-12'
                        phoneCodeValue={this.state.element.ownerPhoneCode}
                        phoneNumberValue={this.state.element.ownerPhoneValue}
                        telephoneCodeOptions={this.state.telephoneCodeOptions}
                        value={this.state.element.ownerPhone}
                        viewMode='EDIT'
                        onChange={this.handleChange}
                        validator={this.validator}
                        renderRequired
                        required={true}
                    />
                    <InputDropdownComponent
                        id='companyBusiness'
                        name='companyBusiness'
                        label={t('autoRegistration.business')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.companyBusiness}
                        viewMode='NEW'
                        validator={this.validator}
                        validators='required'
                        options={this.state.companyBusinessOptions}
                        onChange={this.handleChange}
                        dataKey='id'
                        optionLabel='label'
                        required
                        renderRequired
                    />
                    <InputDropdownComponent
                        id='companyStatus'
                        name='companyStatus'
                        label={t('autoRegistration.companyStatus')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.companyStatus}
                        viewMode='NEW'
                        validator={this.validator}
                        validators='required'
                        options={this.state.companyStatusOptions}
                        onChange={this.handleChange}
                        dataKey='id'
                        optionLabel='label'
                        required
                        renderRequired
                    />
                </div>
                <InputRadioButtonComponent
                    id='companyContactAddress'
                    name='companyContactAddress'
                    label={t('profile.address')}
                    colClass='col-md-6 col-sm-12'
                    value={this.state.element.companyContactAddress}
                    viewMode={'EDIT'}
                    labelOnRight
                    onChange={this.handleChange}
                    options={[
                        {enumValue: 'same', label: 'Ten sam'},
                        {enumValue: 'other', label: 'Inny'},
                    ]}
                    validator={this.validator}
                    valueLabel='label'
                    itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                    validators='required'
                    valueKey='enumValue'
                    required
                    renderRequired
                />
                {this.state.element.companyContactAddress === 'other' ? (
                    <div className='row other-address'>
                        <InputTextComponent
                            id='contactStreet'
                            name='contactStreet'
                            label={t('address.street')}
                            colClass='col-md-4 col-sm-12'
                            value={this.state.element.contactStreet}
                            viewMode='NEW'
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            required
                            renderRequired
                        />
                        <InputTextComponent
                            id='contactNumber'
                            name='contactNumber'
                            label={t('address.houseFlatNumber')}
                            colClass='col-md-4 col-sm-12'
                            value={this.state.element.contactNumber}
                            viewMode='NEW'
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            required
                            renderRequired
                        />
                        <div className='col-12'></div>
                        <InputTextComponent
                            id='contactPostCode'
                            name='contactPostCode'
                            label={t('address.postCode')}
                            colClass='col-md-4 col-sm-12'
                            value={this.state.element.contactPostCode}
                            viewMode='NEW'
                            validator={this.validator}
                            validators='required|zipcode'
                            onChange={this.handleChange}
                            required
                            renderRequired
                        />
                        <InputTextComponent
                            id='contactPostOffice'
                            name='contactPostOffice'
                            label={t('address.town')}
                            colClass='col-md-4 col-sm-12'
                            value={this.state.element.contactPostOffice}
                            viewMode='NEW'
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            required
                            renderRequired
                        />
                    </div>
                ) : null}
                
                <div className='header'>{`5. ${t('autoRegistration.invoiceType')}`}</div>
                <InputRadioButtonComponent
                    id='invoiceType'
                    name='invoiceType'
                    label={t('autoRegistration.invoiceType')}
                    colClass='col-md-6 col-sm-12'
                    value={this.state.element.invoiceType}
                    viewMode={'EDIT'}
                    labelOnRight
                    showLabel={false}
                    options={this.state.invoiceTypeOptions}
                    validator={this.validator}
                    valueLabel='label'
                    itemColClass={'col-12'}
                    validators='required'
                    valueKey='enumValue'
                    onChange={this.handleChange}
                    description='description'
                    showDescription={true}
                    descriptionClassName='p-radiobutton-label'
                    required
                    renderRequired
                />
                <div className='header'>
                    <div>{`6. ${t('autoRegistration.invoiceFrequency')}`}</div>
                    <div className='description-red'>{t('autoRegistration.invoiceFrequencyInfo')}</div>
                </div>

                <InputRadioButtonComponent
                    id='invoiceFrequency'
                    name='invoiceFrequency'
                    label={t('autoRegistration.invoiceFrequency')}
                    colClass='col-md-6 col-sm-12'
                    value={this.state.element.invoiceFrequency}
                    viewMode={'EDIT'}
                    labelOnRight
                    showLabel={false}
                    options={this.state.invoiceFrequencyOptions}
                    validator={this.validator}
                    valueLabel='label'
                    itemColClass={'col-12'}
                    validators='required'
                    valueKey='enumValue'
                    description='description'
                    onChange={this.handleChange}
                    showDescription={true}
                    htmlDescription={true}
                    descriptionClassName='p-radiobutton-label'
                    required
                    renderRequired
                />
                <div className='row footer-buttons'>
                    {this.renderBackButton(0)}
                    {this.renderNextButton(2)}
                </div>
            </DivContainer>
        );
    }

    renderThirdPage() {
        const {t} = this.props;
        const {cards} = this.state.element;
        return (
            <DivContainer colClass='row'>
                <div className='header'>{`7. ${t('autoRegistration.addFuelCards')}`}</div>
                <ul style={{paddingLeft: '20px'}}>
                    <li>{t('autoRegistration.addFuelCards1')}</li>
                    <li>{t('autoRegistration.addFuelCards2')}</li>
                    <li>{t('autoRegistration.addFuelCards3')}</li>
                </ul>
                <DivContainer colClass='row'>
                    {cards !== null && cards !== undefined && cards.length > 0
                        ? cards.map((element, index) => {
                              return (
                                  <div key={`fuel-card-${index}`} className='p-card'>
                                      <div className='row'>
                                          <div className='row p-card-header'>
                                              <div className='col-6 icon-with-text'>
                                                  <img
                                                      src='/images/ico_autoregister_card.svg'
                                                      className='auto-register-ico-menu-card'
                                                      alt='icon card'
                                                  />
                                                  <div>{`${t('autoRegistration.card')} ${index + 1} ${t('autoRegistration.from')} ${
                                                      this.state.element.cards.length
                                                  }`}</div>
                                              </div>
                                              <div className='col-6 delete-card-button'>
                                                  {index !== 0 ? this.renderDeleteCardButton(index) : null}
                                              </div>
                                          </div>
                                          <div className='p-card-content'>
                                              <FuelCardComponent
                                                  idPrefix={index}
                                                  element={element}
                                                  handleChange={this.handleChange}
                                                  validator={this.validator}
                                                  stateField={`element.cards[${index}]`}
                                                  fuelCardTypeOptions={this.state.fuelCardTypeOptions}
                                                  fuelCardAppRoleOptions={this.state.fuelCardAppRoleOptions}
                                                  translation={this.translate}
                                                  handleFuelCardTypeChange={this.handleFuelCardTypeChange(element)}
                                                  phoneCodeOptions={this.state.telephoneCodeOptions}
                                                  chosenOfferType={this.state.element.offerType}
                                                  cardOptions={this.state.cardOptions}
                                                  handleChoosePlasticCardOption={this.handleChoosePlasticCardOption(element)}
                                                  vehicleTypeOpt={this.state.vehicleTypeOpt}
                                              />
                                          </div>
                                      </div>
                                  </div>
                              );
                          })
                        : null}
                </DivContainer>
                <div className='center-div'>
                    {this.state.element.cards.length < this.state.maxFuelCards ? this.renderAddCardButton() : null}
                </div>
                <div className='row footer-buttons'>
                    {this.renderBackButton(1)}
                    {this.renderNextButton(3)}
                </div>
            </DivContainer>
        );
    }

    vehicleTypeTemplate(data, options){
        return options.filter(o=> o.code === data.vehicleType)[0]?.label;
    }

    renderFourthPage() {
        const {t} = this.props;
        const {cards} = this.state.element;
        const {vehicleTypeOpt} = this.state;
        return (
            <DivContainer colClass='row'>
                <div className='header'>{`9. ${t('autoRegistration.cardsOrderSummary')}`}</div>
                <div className='header-2'>{t('autoRegistration.companyNameInfo')}</div>
                <InputTextComponent
                    id='cardCompanyName'
                    name='cardCompanyName'
                    label={t('profile.companyName')}
                    colClass='col-md-6 col-lg-4 col-sm-12'
                    value={this.state.element.cardCompanyName}
                    viewMode='NEW'
                    validator={this.validator}
                    validators='required|max:25'
                    max={25}
                    onChange={this.handleChange}
                    required
                    renderRequired
                    keyfilter={/^[^"]*$/i}
                />
                
                <DivContainer colClass='row'>
                    <DivContainer colClass='row'>
                        <DataTable
                            id='dataTable'
                            key='data-table'
                            emptyMessage={this.translate('list.empty')}
                            className='p-datatable-responsive'
                            responsive
                            value={cards}
                            sortOrder={-1}
                            rows={cards.length}
                            lazy={this.props.lazy}
                            rowClassName={this.props.rowClassName}
                        >
                            <Column field='cardNumber' header={t('autoRegistration.lp')} />
                            <Column field='registrationNumber' header={t('autoRegistration.RegistrationNumber')} />
                            <Column body={(el) => this.vehicleTypeTemplate(el,vehicleTypeOpt)} header={t('autoRegistration.vehicleType')} />
                            <Column field='fuelCardName' header={t('autoRegistration.fuelCardName')} />
                            <Column field='phoneNumber' header={t('autoRegistration.phone')} />
                            <Column body={(el) => t(`AccountRole.${el.fuelCardAppRole}`)} header={t('autoRegistration.appRole')} />
                            <Column body={(el) => t(`EcCardKind.${el.fuelCardType}`)} header={t('autoRegistration.fuelCardType')} />
                            <Column
                                field='fuelCardPlastic'
                                header={t('autoRegistration.cardPlastic')}
                                body={(el) => t(`details.${el.fuelCardPlastic ? 'yes' : 'no'}`)}
                            />
                            {/* <Column
                                header={t('autoRegistration.cost')}
                                body={(list) => {
                                    return `${list.cost} ${t('currency.pln')}`;
                                }}
                            /> */}
                        </DataTable>
                    </DivContainer>
                </DivContainer>
                <div className='header'>{`10. ${t('autoRegistration.checkApprovals')}`}</div>
                <DivContainer>
                    <div className='check-all'>
                        <InputCheckboxComponent
                            id='checkAll'
                            name='checkAll'
                            label={t('autoRegistration.checkAll')}
                            labelOnRight
                            value={this.state.checkAll}
                            onChange={this.state.checkAll ? this.uncheckAll : this.setCheckAll}
                            validator={this.validator}
                            viewMode='NEW'
                            validators='not_required'
                            colClass='col-12'
                        />
                    </div>
                    {this.state.approvals.map((approval, index) => {
                        const label = approval.contents
                            .map((str) => {
                                        return str.type === 'TRANSLATE'
                                    ? t(`${str.content}`)
                                    : `<a href="${str.linkUrl}" target="_blank">${t(str.linkLabel)}</a> `;
                            })
                            .join('');
                        return (
                            <div>
                            <InputCheckboxComponent
                                id={`approval-${index}`}
                                name={`approval-${index}`}
                                label={label}
                                labelOnRight
                                value={this.state.element[`approval-${index}`]}
                                onChange={this.handleChange}
                                validator={this.validator}
                                viewMode='NEW'
                                validators={!!approval.required ? 'required|accepted' : 'not_required'}
                                colClass='col-12'
                                labelClassName='approval-content-title'
                                required={!!approval.required}
                                renderRequired={!!approval.required}
                                validatorLabel=''
                                onAfterStateChange={() => {
                                    const changedElement = this.state.element;
                                    if (approval.approvalType === 'MARKETING' && approval.checkboxes?.length > 0) {
                                        if (!!this.state.element[`approval-${index}`]) {
                                            this.setCheckAllCheckboxForApproval(approval, index);
                                            changedElement.phoneMarketing = true;
                                            changedElement.emailMarketing = true;
                                        } else {
                                            this.unCheckAllCheckboxForApproval(approval, index);
                                            changedElement.phoneMarketing = false;
                                            changedElement.emailMarketing = false;
                                        }
                                    }

                                    if(approval.petraAgreementId !== null ) {
                                        if (!!this.state.element[`approval-${index}`]) {
                                         changedElement.petraAgreements =   this.addPetraAgreementId( approval.petraAgreementId);
                                        } else {
                                            changedElement.petraAgreements =   this.removePetraAgreementId(approval.petraAgreementId);
                                        }
                                        
                                    }
                                 
                                    this.setState((prevState) => ({
                                        ...prevState,
                                        checkAll: true,
                                        element: changedElement,
                                    }));
                                }}
                            />
                            {approval.checkboxes?.length > 0 ? 
                               approval.checkboxes.map((c, cIndex) => {
                                const cLabel = c.contents !== null && c.contents !== undefined && c.contents.length > 0?
                                c.contents.map((str) => {
                                    return str.type === 'TRANSLATE'
                                        ? t(`${str.content}`)
                                        : `<a href="${str.linkUrl}" target="_blank">${t(str.linkLabel)}</a> `;
                                })
                                .join('') : t(`${c.content}`);
                               // const cLabel = t(`${c.content}`)
                                return (
                               <div className='marketingCheckboxes'>
                                <InputCheckboxComponent
                                id={`approval-${index}-checkbox-${cIndex}`}
                                name={`approval-${index}-checkbox-${cIndex}`}
                                label={cLabel}
                                labelOnRight
                                //className={'marketingCheckboxes'}
                                value={this.state.element[`approval-${index}-checkbox-${cIndex}`]}
                                onChange={this.handleChange}
                                validator={this.validator}
                                viewMode='NEW'
                                validators={!!approval.required ? 'required|accepted' : 'not_required'}
                                colClass='col-12'
                                labelClassName='approval-content-title'
                                required={!!approval.required}
                                renderRequired={!!approval.required}
                                validatorLabel=''
                                onAfterStateChange={() => {
                                    const changedElement = this.state.element;
                                    if (c.type === 'MARKETING_PHONE') {
                                        if (!!this.state.element[`approval-${index}-checkbox-${cIndex}`]) {
                                            changedElement.phoneMarketing = true;
                                            this.setApprovalIfAllCheckboxesChecked(approval, index);
                                        } else {
                                            this.unsetApprovalIfAllCheckboxesUnChecked(approval,index);
                                            changedElement.phoneMarketing = false;
                                        }
                                    }
                                    if (c.type === 'MARKETING_EMAIL') {
                                        if (!!this.state.element[`approval-${index}-checkbox-${cIndex}`]) {
                                            changedElement.emailMarketing = true;
                                            this.setApprovalIfAllCheckboxesChecked(approval, index);
                                        } else {
                                            this.unsetApprovalIfAllCheckboxesUnChecked(approval,index);
                                            changedElement.emailMarketing = false;
                                        }
                                    }
                                    this.setState((prevState) => ({
                                        ...prevState,
                                        element: changedElement,
                                    }));
                                    
                                }}
                            />
                               </div>
                               


                                )
                               
                               
                               })  : null
                        
                        }
                            </div>
                            
                        );
                    })}
                </DivContainer>
                <div className='row footer-buttons'>
                    {this.renderBackButton(2)}
                    {this.renderNextButton(4)}
                </div>
            </DivContainer>
        );
    }

    renderFinalPage() {
        const {t} = this.props;
        let success = this.state.errorCode === null || this.state.errorCode === undefined;
        let listCheck = false;
        this.state.element.cards.map((element) => {
            if (element.fuelCardPlastic) {
                listCheck = true;
            }
            return listCheck;
        });
        return (
            <div className='row center'>
                <div className='final-page'>
                    <img src='/images/ico_check.svg' className='auto-register-ico-check' alt='check icon' />
                    <div className='final-header'>
                        {success ? t('autoRegistration.registerText') : t('autoRegistration.registerPendingText')}
                    </div>
                    {success ? <div className='link-header'>{t('autoRegistration.registerLinkText')}</div> : null}
                    <div className='p-card'>
                        <div className='p-card-content'>
                            <img src='/images/login-moya-logo.svg' className='login-moya-logo' alt='logo moya' />
                            <div className='header'>{t('autoRegistration.registerWelcome')}</div>
                            {this.state.element.offerType === 'PREPAID' ? (
                                <label className='red-font-color'>{t('autoRegistration.loginDataSent')}</label>
                            ) : null}
                            <div>
                                {t('autoRegistration.registerOffice')}
                                <ul>
                                    <li>{t('autoRegistration.registerOffice1')}</li>
                                    <li>{t('autoRegistration.registerOffice2')}</li>
                                    <li>{t('autoRegistration.registerOffice3')}</li>
                                    {this.state.element.offerType === 'PREPAID' ? <li>{t('autoRegistration.registerOffice4')}</li> : null}
                                </ul>
                            </div>
                            <div className='center-div'>{this.renderBackButton()}</div>
                        </div>
                    </div>
                    {listCheck ? (
                        <div>
                            <div className='final-header'>{t('autoRegistration.registerCardsText')}</div>
                            <div className='final-adress'>{this.state.element.companyName}</div>
                            <div className='final-adress'>
                                {this.state.element.companyContactAddress === 'other'
                                    ? `${this.state.element.contactStreet} ${this.state.element.contactNumber}\n${this.state.element.contactPostCode} ${this.state.element.contactPostOffice}`
                                    : `${this.state.element.fullAddress.street} ${this.state.element.fullAddress.streetNumber}\n${this.state.element.fullAddress.postCode} ${this.state.element.fullAddress.city}`}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
    setCheckAll() {
        const changedElement = this.state.element;
        changedElement.phoneMarketing = true;
        changedElement.emailMarketing = true;
        this.state?.approvals?.forEach((approval, index) => {
            changedElement[`approval-${index}`] = true;
            if(approval.petraAgreementId !== null ) {
                if (!!this.state.element[`approval-${index}`]) {
                 changedElement.petraAgreements =   this.addPetraAgreementId( approval.petraAgreementId);
                }  
            }
            if(approval.checkboxes.length > 0){
                approval.checkboxes.forEach((c, cIndex) => {
                    changedElement[`approval-${index}-checkbox-${cIndex}`] = true;
                })
            }
        });
        this.setState((prevState) => ({
            ...prevState,
            checkAll: true,
            element: changedElement,
        }));
    }

    setCheckAllCheckboxForApproval( approval, approvalIndex){
        const changedElement = this.state.element;
        changedElement.phoneMarketing = true;
        changedElement.emailMarketing = true;
       // let appr = this.state.element[`approval-${approvalIndex}`];
       
            approval.checkboxes.forEach((c, cIndex) => {
                changedElement[`approval-${approvalIndex}-checkbox-${cIndex}`] = true;
            })
        
        this.setState((prevState) => ({
            ...prevState,
            element: changedElement,
        }));
    }
    unCheckAllCheckboxForApproval(approval, approvalIndex){
        const changedElement = this.state.element;
        changedElement.phoneMarketing = false;
        changedElement.emailMarketing = false;
      //  let appr = this.state.element[`approval-${approvalIndex}`];
       
            approval.checkboxes.forEach((c, cIndex) => {
                changedElement[`approval-${approvalIndex}-checkbox-${cIndex}`] = false;
            })
        

        this.setState((prevState) => ({
            ...prevState,
            element: changedElement,
        }));
    }
    setApprovalIfAllCheckboxesChecked( approval, approvalIndex){
        const changedElement = this.state.element;
    /*     let counter = 0;
            approval.checkboxes.forEach((c, cIndex) => {
                if( changedElement[`approval-${approvalIndex}-checkbox-${cIndex}`] === true){
                    counter += 1;
                }
            });

            if(counter ===  approval.checkboxes.length){
                changedElement[`approval-${approvalIndex}`] = true;
            } */
            changedElement[`approval-${approvalIndex}`] = true;
        this.setState((prevState) => ({
            ...prevState,
            element: changedElement,
        }));
    }
    unsetApprovalIfAllCheckboxesUnChecked( approval, approvalIndex){
        const changedElement = this.state.element;
        let counter = 0;
            approval.checkboxes.forEach((c, cIndex) => {
                if( changedElement[`approval-${approvalIndex}-checkbox-${cIndex}`] === false){
                    counter += 1;
                }
            });

            if(counter ===  approval.checkboxes.length){
                changedElement[`approval-${approvalIndex}`] = false;
            }
          
        this.setState((prevState) => ({
            ...prevState,
            element: changedElement,
        }));
    }

    addPetraAgreementId(petraAgreementId) {
        let modifiedList = this.state.element.petraAgreements;;
            if(modifiedList.filter(el => el === petraAgreementId).length === 0){
                modifiedList.push(petraAgreementId);
            } 
             return modifiedList;
    }
    removePetraAgreementId(petraAgreementId) {
        let modifiedList = this.state.element.petraAgreements;
            if(modifiedList.filter(el => el === petraAgreementId).length > 0){
            let afterRemove  =  modifiedList.filter(el => el !== petraAgreementId);
                return afterRemove;
            }
           else  return modifiedList;
       
    }

    uncheckAll() {
        const changedElement = this.state.element;
        changedElement.phoneMarketing = false;
        changedElement.emailMarketing = false;
        this.state?.approvals?.forEach((approval, index) => {
            changedElement[`approval-${index}`] = false;
            if(approval.petraAgreementId !== null ) {
                if (!this.state.element[`approval-${index}`]) {
                 changedElement.petraAgreements =   this.removePetraAgreementId( approval.petraAgreementId);
                } 
            }
            if(approval.checkboxes.length > 0){
                approval.checkboxes.forEach((c, cIndex) => {
                    changedElement[`approval-${index}-checkbox-${cIndex}`] = false;
                })
            }
        });
        this.setState((prevState) => ({
            ...prevState,
            checkAll: false,
            element: changedElement,
        }));
    }

    checkCheckAll() {
        let isUnchecked;
        const changedElement = this.state.element;
        this.state?.approvals?.forEach((approval, index) => {
            if (!changedElement[`approval-${index}`]) {
                isUnchecked = true;
                return;
            }
        });

        if (this.state.checkAll && isUnchecked) {
            this.setState((prevState) => ({
                ...prevState,
                checkAll: false,
            }));
        }
    }

    renderBackButton(pageNumber) {
        const {t} = this.props;
        return (
            <ActionButton
                label={
                    this.state.pageIndex === 0
                        ? t('details.cancel')
                        : this.state.pageIndex === 4
                        ? this.state.errorCode === undefined
                            ? t('autoRegistration.registerLogin')
                            : t('autoRegistration.registerClose')
                        : t('details.back')
                }
                variant={this.state.pageIndex === 4 ? 'back-button blue' : 'back-button white m'}
                colClass=''
                href='/#/start'
                handleClick={
                    this.state.pageIndex !== 0 && this.state.pageIndex !== 4
                        ? (e) => {
                              e.preventDefault();
                              this.setState({pageIndex: pageNumber});
                              this.scrollToTop();
                          }
                        : null
                }
            />
        );
    }

    renderToLoginButton() {
        const {t} = this.props;
        return <ActionButton label={t('autoRegistration.returnToLogin')} variant='to-login-button white m' href='/#/start' />;
    }

    renderNextButton(pageNumber) {
        const {t} = this.props;
        let label;
        switch (this.state.pageIndex) {
            case 0:
                label = `${t('details.forward')} - ${t('autoRegistration.settlemetData')}`;
                break;
            case 1:
                label = `${t('details.forward')} - ${t('autoRegistration.cardType')}`;
                break;
            case 2:
                label = `${t('details.forward')} - ${t('autoRegistration.summary')}`;
                break;
            case 3:
                label = t('autoRegistration.placeOrder');
                break;
            default:
                label = t('details.forward');
                break;
        }
        return (
            <ActionButton
                label={label}
                variant='next-button blue m'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    if(this.state.pageIndex === 1 && this.state.element.flatRateFarmer !== undefined){
                        if(this.state.element.flatRateFarmer === 'SELF_EMPLOYED' ){
                            this.blockUi();
                            this.handleFormSubmit(e, pageNumber);
                        } else if(this.state.element.flatRateFarmer === 'FLAT_RATE_FARMER' ){
                            this.handleFormSubmit(e, pageNumber-1);
                        }
                    } else {
                        this.blockUi();
                        this.handleFormSubmit(e, pageNumber);
                    }
                }}
            />
        );
    }

    saveFlatRateFarmerStatement(){
        const {element} = this.state;
        const {t} = this.props;
        let request = {
                        "tin": element.tin,
                        "email": element.ownerEmail,
                        "name": element.companyName,
                        "ip": element.userIp,
                        "flatRateFarmer": element.flatRateFarmer
        };
        this.autoRegistrationService.saveFlatRateFarmerStatement(request)
        .then((res)=>{
            this.showInfoMessage(t('autoRegistration.successFarmerStatement'));  
        })
        .catch((err) => {
            this.showInfoMessage(t('autoRegistration.errorFarmerStatement'));  
        })
    }
    handleOpenFlatRateFarmerDialog(){
        this.setState({flatRateFarmerDialogVisible: true});
    }
    handleCloseFlatRateFarmerDialog(){
        this.setState({flatRateFarmerDialogVisible: false});
    }

    handleFormSubmit(event, pageNumber) {
        const {t} = this.props;
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            this.messages.clear();
            this.validator.hideMessages();
            if(this.state.pageIndex === 1 && this.state.element.flatRateFarmer === 'FLAT_RATE_FARMER'){
                this.handleOpenFlatRateFarmerDialog();
                this.saveFlatRateFarmerStatement();
            } else {
                switch (this.state.pageIndex) {
                    case 0: {
                        if (!this.state.element.offerType) {
                            this.showErrorMessage(t('error.offerErrorMessage'));
                            this.unblockUi();
                            return;
                        }
                        this.autoRegistrationService
                            .registrationValidateCustomerAndEmail(this.normalizeNip(), this.state.element?.ownerEmail)
                            .then((response) => {
                                if (!!response.emailErrorCode || !!response.customerErrorCode) {
                                    if (!!response.emailErrorCode) {
                                        this.showErrorMessage(t(`error.getRegistrationEmailErrorCode.${response.emailErrorCode}`));
                                    }
                                    if (!!response.customerErrorCode) {
                                        this.showErrorMessage(t(`error.getRegistrationCustomerErrorCode.${response.customerErrorCode}`));
                                    }
                                } else if (response?.customers.length === 1 && response?.emailValidated) {
                                    const customer = response?.customers[0];
                                    this.setState(
                                        (prevState) => ({
                                            prevState,
                                            pageIndex: pageNumber,
                                            element: {
                                                ...prevState.element,
                                                fullAddress: {
                                                    city: customer.fullAddress.city,
                                                    street: customer.fullAddress.street,
                                                    streetNumber: customer.fullAddress.streetNumber,
                                                    flatNumber: customer.fullAddress.flatNumber,
                                                    postCode: customer.fullAddress.postCode,
                                                    postOffice: customer.fullAddress.postOffice,
                                                    provinceId: customer.fullAddress.provinceId,
                                                },
                                                companyName: customer.fullName,
                                                email: customer.email,
                                                existsInOtherRole: customer.existsInOtherRole,
                                                regon: customer.regon,
                                                cbkId: customer.cbkId,
                                                customerDataChange: customer.customerDataChange,
                                            },
                                        }),
                                        this.registrationStart()
                                    );
                                } else if (response?.customers.length > 1 && response?.emailValidated) {
                                    this.setState({selectCustomerDialogVisible: true, customerOptions: response.customers});
                                }
                                this.unblockUi();
                            });
                        return;
                    }
                    case 1:
                            this.addFuelCard(this.state.element.ownerPhoneCode, this.state.element.ownerPhoneValue, 'ADMIN');  
                        break;
                    case 2:
                        this.state.element.cards.forEach((el) => {
                            if (
                                el.phoneNumberCode !== undefined &&
                                el.phoneNumberCode !== null &&
                                el.phoneNumberValue !== undefined &&
                                el.phoneNumberValue !== null &&
                                el.phoneNumberValue !== ''
                            ) {
                                el.phoneNumber = el.phoneNumberCode.code + el.phoneNumberValue;
                            }
                        });
                        break;
                    case 3:
                        this.saveFlatRateFarmerStatement();
                        this.completeRegistration();
                        return;
                    default:
                        break;
                }
            }
        

            this.blockUi(this.setState({pageIndex: pageNumber}));
            this.scrollToTop();
            this.unblockUi();
        } else {
            this.validator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
            this.unblockUi();
        }
    }

    renderAddCardButton() {
        const {t} = this.props;
        return (
            <ActionButton
                label={t('autoRegistration.addCard')}
                variant='add-card-button white m'
                handleClick={(e) => {
                    e.preventDefault();
                    this.addFuelCard();
                }}
            />
        );
    }

    renderDeleteCardButton(index) {
        const {t} = this.props;
        return (
            <ActionLink
                label={t('autoRegistration.deleteCard')}
                variant='button white-black height-88'
                className='delete-card-button'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    this.deleteFuelCard(index);
                }}
            />
        );
    }

    addFuelCard(phoneNumberCode, phoneNumberValue, appRole) {
        let object = {
            uuid: uuidv4(),
            fuelCardType: undefined,
            fuelCardAppRole: appRole ? appRole : 'DRIVER',
            fuelCardVirtual: true,
            fuelCardPlastic: false,
            phoneNumberCode,
            phoneNumberValue,
            fuelCardName: '',
            registrationNumber: '',
            electromobility: false,
        };
        if (this._isMounted && this.state.element.cards.length < this.state.maxFuelCards) {
            const cards = this.state.element.cards ? this.state.element.cards : [];
            cards.push(object);
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    cards: cards,
                },
            }));
        }
    }

    deleteFuelCard(index) {
        if (this._isMounted && this.state.element.cards) {
            let cards = this.state.element.cards;
            cards.splice(index, 1);
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    cards: cards,
                },
            }));
        }
    }

    renderStepsNav() {
        const {t} = this.props;
        const items = [
            {label: t('autoRegistration.paymentMethod')},
            {label: t('autoRegistration.settlemetDataUp')},
            {label: t('autoRegistration.cardTypeUp')},
            {label: t('autoRegistration.summaryUp')},
        ];
        return (
            <div className='col-md-8 col-sm-12'>
                <Steps
                    model={items}
                    activeIndex={this.state.pageIndex}
                    icons
                    activeIconSrc='/images/ico_steps_check.svg'
                    completedIconsSrc='/images/ico_blue_dot_of_doom.svg'
                    nextIconsSrc='/images/ico_steps_next.svg'
                />
            </div>
        );
    }

    handleFuelCardTypeChange(element) {
        if (element) {
            switch (element.fuelCardType) {
                case 'FIRM':
                    element.registrationNumber = '';
                    element.fuelCardName = '';
                    break;
                case 'VEHICLE':
                    element.fuelCardName = '';
                    break;
                case 'PERSON':
                    element.registrationNumber = '';
                    break;
                default:
                    break;
            }
        }
    }
    handleChoosePlasticCardOption(element) {
        if (element) {
            switch (element.cardOption) {
                case 'PLASTIC_MULTIENERGETIC':
                    element.electromobility = true;
                    break;
                case 'PLASTIC':
                    element.electromobility = false;
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        return (
            <DivContainer colClass='container-fluid auto-register'>
                <DivContainer colClass='dashboard auto-register-container'>
                    <BlockUi
                        tag='div'
                        blocking={this.state.blocking || this.state.loading}
                        loader={this.loader}
                        rendered={!this.props.embedded}
                    >
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                        {this.renderDetails()}
                    </BlockUi>
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                </DivContainer>
            </DivContainer>
        );
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <div className='container-fluid'>
                        {this.state.pageIndex !== 0 && this.state.pageIndex !== 4 ? this.renderToLoginButton() : null}
                        <div className='auto-register'>
                            <div className='register-header'>
                                {this.state.pageIndex !== 4 ? <div>{t('autoRegistration.moyaRegister')}</div> : null}
                                <div>{this.state.pageIndex !== 4 ? this.renderStepsNav() : null}</div>
                            </div>

                            {this.state.pageIndex === 0 ? this.renderFirstPage() : null}
                            {this.state.pageIndex === 1 ? this.renderSecondPage() : null}
                            {this.state.pageIndex === 2 ? this.renderThirdPage() : null}
                            {this.state.pageIndex === 3 ? this.renderFourthPage() : null}
                            {this.state.pageIndex === 4 ? this.renderFinalPage() : null}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

AutoRegistrationContainer.defaultProps = {};

AutoRegistrationContainer.propTypes = {};

export default withTranslation()(AutoRegistrationContainer);
